import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { CivicFacilitiesModel } from 'types/api'
import { BaseParams } from 'types/utils'
import { civicFacilitiesQueryKey } from './useCivicFacilities'

export function usePatchCivicFacilities() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()

  async function patchCivicFacility({
    id,
    body
  }: BaseParams<CivicFacilitiesModel, 'PATCH'>) {
    const response = await apiClient.patch<CivicFacilitiesModel>(
      SNA_PREFIX + `civic-facilities/${id}`,
      body
    )
    return response.data
  }

  return useMutation({
    mutationFn: patchCivicFacility,
    onSuccess: () => {
      toast.success({ message: t('civicFacilityUpdated') })
      queryClient.invalidateQueries({ queryKey: [...civicFacilitiesQueryKey] })
    },
    onError: () => {
      toast.error({ message: t('civicFacilityUpdateError') })
    }
  })
}
